import { useRouter } from "next/router";
import { Footer } from "@nju/feature-portal-footer";
import { Header } from "@nju/feature-portal-header";
import { portalRoutes } from "@nju/routes";
import { BlockContent, GeneralErrorNotification, LayoutWrapper } from "@nju/ui";
import { ClientSideOnly } from "../components/ClientSideRenderer";

export default function NoPesel() {
  const router = useRouter();

  return (
    <LayoutWrapper>
      <Header />
      <ClientSideOnly>
        <BlockContent grid="default" spacing="xl" tone="none">
          <GeneralErrorNotification
            callback={() => {
              router.replace(portalRoutes.mojeKonto.index.get());
            }}
            copy="powrót"
            description="Czekamy na potwierdzenie Twojej tożsamości przez technika. Po zakończonej weryfikacji będzie można zakupić nju abonament."
            icon="times-circle"
            title="Twoje zamówienie nju światłowód  jest w realizacji"
          />
        </BlockContent>
      </ClientSideOnly>
      <Footer />
    </LayoutWrapper>
  );
}
